/**
 * Shared CRM status / type / priority presentation helpers.
 */
import type { BadgeProps } from '@/components/ui/Badge';
import type {
  CrmTicketPriority,
  CrmTicketStatus,
  CrmTicketType,
  CrmRefundDecision,
  CrmShrinkageStatus,
} from '@/api/bi/crm';

type Tone = NonNullable<BadgeProps['tone']>;

export const TICKET_TYPE_LABEL: Record<CrmTicketType, string> = {
  sla_breach: 'SLA Breach',
  customer_delay: 'Customer Delay',
  cancellation: 'Cancellation',
  refund: 'Refund',
  shrinkage: 'Shrinkage',
  channel_escalation: 'Channel Escalation',
  damage: 'Cycle Damage',
};

export const TICKET_STATUS_LABEL: Record<CrmTicketStatus, string> = {
  open: 'Open',
  investigating: 'Investigating',
  waiting_customer: 'Waiting on customer',
  escalated: 'Escalated',
  resolved: 'Resolved',
  rejected: 'Rejected',
};

export const TICKET_STATUS_TONE: Record<CrmTicketStatus, Tone> = {
  open: 'info',
  investigating: 'warning',
  waiting_customer: 'primary',
  escalated: 'danger',
  resolved: 'success',
  rejected: 'neutral',
};

export const TICKET_PRIORITY_LABEL: Record<CrmTicketPriority, string> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  critical: 'Critical',
};

export const TICKET_PRIORITY_TONE: Record<CrmTicketPriority, Tone> = {
  low: 'neutral',
  normal: 'info',
  high: 'warning',
  critical: 'danger',
};

export const TICKET_TYPE_TONE: Record<CrmTicketType, Tone> = {
  sla_breach: 'warning',
  customer_delay: 'info',
  cancellation: 'danger',
  refund: 'primary',
  shrinkage: 'danger',
  channel_escalation: 'warning',
  damage: 'danger'
};

export const REFUND_DECISION_TONE: Record<CrmRefundDecision, Tone> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'danger',
};

export const SHRINKAGE_STATUS_TONE: Record<CrmShrinkageStatus, Tone> = {
  reported: 'warning',
  verified: 'info',
  approved: 'success',
  rejected: 'neutral',
};

export const OPEN_TICKET_STATUSES: CrmTicketStatus[] = [
  'open',
  'investigating',
  'waiting_customer',
  'escalated',
];

export function isOpenStatus(status: CrmTicketStatus): boolean {
  return OPEN_TICKET_STATUSES.includes(status);
}
